import React, { useEffect, useRef } from 'react';
import classes from './About.module.css';
import { Link } from 'react-router-dom';
// import { HashLink } from "react-router-hash-link";
import ScrollDown from '../UI/ScrollDownIndicator/ScrollDown';
import AboutShapes from '../UI/Shapes/AboutShapes';
import Header from '../UI/Header/Header';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Skills from '../UI/Skills/Skills';
import Canvas from '../Canvas/Canvas';
// import SplitText from "../UI/SplitText/SplitText";
// import ScrollDown from "../UI/ScrollDownIndicator/ScrollDown";

const About = () => {
  gsap.registerPlugin(ScrollTrigger);
  const head1 = useRef();
  const head2 = useRef();
  const head3 = useRef();
  const head4 = useRef();
  let tl = new gsap.timeline();
  useEffect(() => {
    // Gsap Animations....
    tl.from(head1.current, {
      color: '#000',
      rotation: '180deg',
      fontSize: '0px'
    }).to(head1.current, {
      scrollTrigger: {
        trigger: head1.current,
        toggleActions: 'restart pause reverse reset',
        scrub: true,
        start: '-900',
        end: '-200'
      },
      rotation: '0deg',
      color: '#3abdf1',
      duration: 1,
      fontSize: 'calc(2rem + 7vw)'
    });

    tl.from(head2.current, {
      color: '#000',
      rotation: '-180deg',
      fontSize: '0px'
    }).to(head2.current, {
      scrollTrigger: {
        trigger: head2.current,
        toggleActions: 'restart pause reverse reset',
        scrub: true,
        start: '-900',
        end: '-200'
      },
      rotation: '0deg',
      duration: 1,
      color: '#3abdf1',
      fontSize: 'calc(2rem + 7vw)'
    });
    tl.from(head3.current, {
      color: '#000',
      rotation: '180deg',
      fontSize: '0px'
    }).to(head3.current, {
      scrollTrigger: {
        trigger: head3.current,
        toggleActions: 'restart pause reverse reset',
        scrub: true,
        start: '-900',
        end: '-200'
      },
      rotation: '0deg',
      duration: 1,
      color: '#3abdf1',
      fontSize: 'calc(2rem + 7vw)'
    });
    tl.from(head4.current, {
      color: '#000',
      rotation: '-180deg',
      fontSize: '0px'
    }).to(head4.current, {
      scrollTrigger: {
        trigger: head4.current,
        toggleActions: 'restart pause reverse reset',
        scrub: true,
        start: '-900',
        end: '-200'
      },
      rotation: '0deg',
      duration: 1,
      color: '#3abdf1',
      fontSize: 'calc(2rem + 7vw)'
    });
    // AOS Animations
    AOS.init({
      // once: true,
      duration: 1000
    });
  });

  return (
    <>
      <AboutShapes />
      <section className={classes.about}>
        <Canvas />
        <Header header="ABOUT" styles={classes['about-text']} />

        <ScrollDown link="#section1" />
      </section>
      <section id="section1" className={classes['section-one']}>
        <div>
          <h1 ref={head1} className={classes.title}>
            <span>W</span>
            <span>H</span>
            <span>O</span>
            <span>?</span>
          </h1>
        </div>
        <div>
          <p data-aos={'fade-up'} className={classes.description}>
            I am a Fullstack developer, formed through the love of designing and
            building wonderlicious internet-things. Currently I am a student at
            D.Y. Patil College of Engineering, Pune.{' '}
          </p>
        </div>
      </section>
      <section className={classes['section-two']}>
        <div>
          <p data-aos={'fade-up'} className={classes.description}>
            The goal is simple; to create excellent websites/apps that make
            myself shine and my ego soar.{' '}
          </p>
          <Link
            data-aos={'fade-up'}
            data-aos-delay={'200'}
            to="/projects"
            className={classes['about-link']}
          >
            View Projects
            <svg
              stroke="currentColor"
              fill="none"
              strokeWidth="2"
              viewBox="0 0 24 24"
              strokeLinecap="round"
              strokeLinejoin="round"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </Link>
        </div>
        <div>
          <h1 ref={head2} className={classes.title}>
            HUH?
          </h1>
        </div>
      </section>
      <section className={classes['section-three']}>
        <div>
          <h1 ref={head3} className={classes.title}>
            WHAT?
          </h1>
        </div>
        <div className={classes.skills_container}>
          <p data-aos={'fade-up'} className={classes['tech-description']}>
            SOME WEB TECH I LIKE TO USE IS:{' '}
          </p>
          <ul
            data-aos={'fade-up'}
            data-aos-delay={'200'}
            className={classes['tech-list']}
          >
            {/* <li>HTML</li>
            <li>CSS</li>
            <li>JAVASCRIPT</li>
            <li>REACT.JS</li>
            <li>NEXT.JS</li>
            <li>NODE.JS</li>
            <li>EXPRESS.JS</li>
            <li>MONGODB</li>
            <li>GSAP</li>
            <li>TYPESCRIPT</li>
            <li>THREE.JS</li>
            <li>TAILWIND CSS</li>
            <li>STYLED COMPONENTS</li> */}
            <Skills />
          </ul>
        </div>
      </section>
      <section className={classes['section-four']}>
        <div>
          <p data-aos={'fade-up'} className={classes.description}>
            So, if you have an idea and want someone to have a look at it? Get
            in touch or something.
          </p>
          <Link
            data-aos={'fade-up'}
            data-aos-delay={'200'}
            to="/contact"
            className={classes['about-link']}
          >
            Get in Touch
            <svg
              stroke="currentColor"
              fill="none"
              strokeWidth="2"
              viewBox="0 0 24 24"
              strokeLinecap="round"
              strokeLinejoin="round"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </Link>
        </div>
        <div>
          <h1 ref={head4} className={classes.title}>
            SO?
          </h1>
        </div>
      </section>
    </>
  );
};

export default About;
